import React, { useState } from 'react';
import { OrderGuideButton } from './order-guide-button';
import { useMultiOrderGuideMutations } from '@/hooks/use-multi-order-guide-mutations';
import { useNewOrderContext } from '@/contexts/new-order-context';
import { useOrderGuideItemsContext } from '@/contexts/order-guide-items-context';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  openPartitionSelector: () => void;
  variantPackUUID: string;
}

export const MultiOrderGuideButton: React.FC<Props> = ({
  openPartitionSelector,
  variantPackUUID,
}) => {
  const { showErrorToast } = useToasts();
  const { customOrderGuideEditingEnabled } = useNewOrderContext();
  const { collections, isInOrderGuide } = useOrderGuideItemsContext();
  const { addToOrderGuide, removeFromOrderGuide } =
    useMultiOrderGuideMutations();

  const [isAddedOverride, setIsAddedOverride] = useState<boolean | null>(null);

  // Disable if order guide editing is not enabled or if all collections are locked
  const isDisabled =
    !customOrderGuideEditingEnabled ||
    collections.every((collection) => collection.isLocked);

  return (
    <OrderGuideButton
      disabled={isDisabled}
      isAdded={isAddedOverride ?? isInOrderGuide(variantPackUUID)}
      onPress={async () => {
        if (typeof isAddedOverride === 'boolean') {
          return;
        }
        if (
          collections.length === 1 &&
          collections[0].partitions.length === 1
        ) {
          const defaultCollectionPartitionUUID =
            collections[0].partitions[0].uuid;
          try {
            if (isInOrderGuide(variantPackUUID)) {
              setIsAddedOverride(false);
              await removeFromOrderGuide(
                defaultCollectionPartitionUUID,
                variantPackUUID,
              );
            } else {
              setIsAddedOverride(true);
              await addToOrderGuide(
                defaultCollectionPartitionUUID,
                variantPackUUID,
              );
            }
          } catch (e) {
            showErrorToast();
          } finally {
            setIsAddedOverride(null);
          }
        } else {
          openPartitionSelector();
        }
      }}
      variantPackUUID={variantPackUUID}
    />
  );
};
